import React from 'react';
import {
  BrowserRouter,
  Switch,
  Route as DomRoute,
  useLocation, Redirect
} from 'react-router-dom';
import { Layout } from './layout/layout';
import { useAuth, useContext } from './context';
import { Login } from './login/login';
import { Logout } from './login/logout';
import { Preloader } from './components/preloader';
import { Orders } from './directBanking/orders/orders';
import { OrdersDetails } from './directBanking/orders/ordersDetails';
import { DirectBankingFees } from './directBanking/fees/fees';
import { Reports } from './directBanking/reports/reports';
import { NewOrder } from './directBanking/orders/newOrder';

const PrivateRoute = (
  { name, component: Component, ...rest }:
    { name: string, component: any, exact?: boolean, path: string[] | string }
) => {
  const context = useContext();
  return (
    <DomRoute
      {...rest}
      render={(props) => {
        if (context.data.isSignedIn) {
          return (<Layout name={name}><Component {...props} /></Layout>)
        } else {
          return <Redirect to='/login' />
        }
      }}
    />
  )
}

const PublicRoute = (
  { component: Component, ...rest }:
    { component: any, exact?: boolean, path: string[] | string }
) => {
  return (
    <DomRoute
      {...rest}
      render={(props) => {
        return (<Component {...props} />)
      }}
    />
  )
}

const ScrollToTop = () => {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

export const Router = () => {
  const auth = useAuth();
  const context = useContext();
  React.useEffect(() => {
    auth.attemptCookieLogin();
  }, []);
  if (context.data.initializing) {
    return (<Preloader />);
  } else {
    return (
      <BrowserRouter>
        <ScrollToTop />
        <Switch>
          <PublicRoute exact path='/login' component={Login} />
          <PrivateRoute exact name={'LOGOUT'} path='/logout' component={Logout} />

          <PrivateRoute exact name={'FEES'} path='/fees' component={DirectBankingFees} />

          <PrivateRoute exact name={'ORDERS'} path='/orders' component={Orders} />
          <PrivateRoute exact name={'ORDER_DETAILS'} path='/orders/:id' component={OrdersDetails} />

          <PrivateRoute exact name={'REPORTS'} path='/reports' component={Reports} />

          <PrivateRoute exact name={'NEW_ORDER'} path='/directbanking/orders/new_order' component={NewOrder} />

          <Redirect to='/orders' />
        </Switch>
      </BrowserRouter>
    );
  }
}
